/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Error_PagesInputs */

const en_player_error_pages = /** @type {(inputs: Player_Error_PagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error loading course content`)
};

const ja_player_error_pages = /** @type {(inputs: Player_Error_PagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コースコンテンツの読み込みエラー`)
};

const fr_player_error_pages = /** @type {(inputs: Player_Error_PagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreur lors du chargement du contenu du cours`)
};

const de_player_error_pages = /** @type {(inputs: Player_Error_PagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler beim Laden des Kursinhalts`)
};

/**
* | output |
* | --- |
* | "Error loading course content" |
*
* @param {Player_Error_PagesInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const player_error_pages = /** @type {((inputs?: Player_Error_PagesInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Error_PagesInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_player_error_pages(inputs)
	if (locale === "ja") return ja_player_error_pages(inputs)
	if (locale === "fr") return fr_player_error_pages(inputs)
	return de_player_error_pages(inputs)
});